module.exports = "/images/hero-002@2x.png?cbb74e7b91662d88043d33e2dcca16c5";